module.exports = __webpack_public_path__ + "static/media/sho.87040836.png";